module.exports = __webpack_public_path__ + "img/shop2-2.ca273355.png";